import { withStyles } from '@material-ui/core/styles';
import { REGION_LIST_TITLE } from '../../libraries/texts';
import service from '../../services/region-service';

import ListForm from '../maintainer/list';
import { MaintainerList as styles } from '../maintainer/styles';

export default withStyles(styles)(ListForm({ service, title: REGION_LIST_TITLE, name: 'REGION' }));
